(function() {
    'use strict';

    var DatiCredenzialiCtrl = function(
        messaggiFctr,
        datiCredenzialiService,
        gestioneUtenteService
    ) {

        this.loading = 0;
        this.gestioneUtenteService = gestioneUtenteService;
        this.datiCredenzialiService = datiCredenzialiService

        this.isCertificazioneCaricata = () => {
            let ndg = this.gestioneUtenteService.praticaPic.intestatario.ndg;
            let service = datiCredenzialiService.contattiCertificati[ndg];
            return !!service;
        };

        this.isTelefonoCertificato = () => {
            if (!this.isCertificazioneCaricata()) {
                return false;
            }
            let ndg = this.gestioneUtenteService.praticaPic.intestatario.ndg;
            let service = datiCredenzialiService.contattiCertificati[ndg];
            if (!service.telefono) {
                return false;
            }
            if (!this.gestioneUtenteService.datiMito.elencoContatti[0] || 
                !this.gestioneUtenteService.datiMito.elencoContatti[0].prefisso || 
                !this.gestioneUtenteService.datiMito.elencoContatti[0].numero) {
                return false;
            }

            let telefonoAttuale = this.gestioneUtenteService.datiMito.elencoContatti[0].prefisso.trim() + this.gestioneUtenteService.datiMito.elencoContatti[0].numero.trim();
            // Nel confronto va rimosso il carattere '+': nei prefissi di Mito non viene salvato
            return (service.telefono.replace('+', '') == telefonoAttuale.replace('+', ''));
        };

        this.isMailCertificata = () => {
            if (!this.isCertificazioneCaricata()) {
                return false;
            }
            let ndg = this.gestioneUtenteService.praticaPic.intestatario.ndg;
            let service = datiCredenzialiService.contattiCertificati[ndg];
            if (!service.email) {
                return false;
            }
            if (!this.gestioneUtenteService.datiMito.email) {
                return false;
            }

            let emailAttuale = this.gestioneUtenteService.datiMito.email.toLowerCase().trim();
            return (service.email == emailAttuale);
        };

        this.getCertificazioneContatto = () => {
            datiCredenzialiService.contattiCertificati = {};
            let ndg = this.gestioneUtenteService.praticaPic.intestatario.ndg;
            if (!ndg) return;
            datiCredenzialiService.getCertificazioneContatto(ndg).then(
                (resp) => {
                    if (!resp.data.result) return;
                    datiCredenzialiService.contattiCertificati[ndg] = { 
                        telefono: (resp.data.result.telefono || "").trim(), 
                        email: (resp.data.result.email || "").toLowerCase().trim() 
                    };
                },
                (error) => messaggiFctr.processaResponse(error)
            )
        };

        this.checkContattiAnagrafici = () => {
            let ndg = this.gestioneUtenteService.praticaPic.intestatario.ndg;
            if (!ndg) return;
            datiCredenzialiService.getContattiAnagrafici(ndg).then(
                (resp) => {
                    if (!resp.data.result) return;

                    let contatti = this.gestioneUtenteService.datiMito.elencoContatti;
                    if (!contatti || !angular.isArray(contatti)) {
                        contatti = [];
                    }
                    if (contatti.length == 0) {
                        contatti.push({ principale: 1 });
                    }
                    let prefissoAttuale = contatti[0].prefisso;
                    if (!prefissoAttuale) {
                        contatti[0].prefisso = '+39';
                    }
                    let numeroAttuale = contatti[0].numero;
                    if (!numeroAttuale && resp.data.result.telefono) {
                        if (!datiCredenzialiService.listaPrefissi || (datiCredenzialiService.listaPrefissi.length == 0)) {
                            contatti[0].numero = resp.data.result.telefono;
                            contatti[0].principale = 1;
                        } else {
                            let numeroTelefonoAnagrafico = resp.data.result.telefono;
                            datiCredenzialiService.listaPrefissi.forEach((elemento) => {
                                let prefix = '+' + elemento.codice;
                                if (numeroTelefonoAnagrafico.startsWith(prefix)) {
                                    contatti[0].principale = 1;
                                    contatti[0].prefisso = prefix;
                                    contatti[0].numero = numeroTelefonoAnagrafico.substring(prefix.length);
                                }
                            });
                        }
                    }
                    this.gestioneUtenteService.datiMito.elencoContatti = contatti;

                    this.getCertificazioneContatto();
                },
                (error) => messaggiFctr.processaResponse(error)
            )
        };

        this.getPrefissi = (callback) => {
            datiCredenzialiService.listaPrefissi = [];
            datiCredenzialiService.getPrefissi().then(
                (resp) => {
                    resp.data.forEach((prefisso) => {
                        datiCredenzialiService.listaPrefissi.push({ codice: prefisso.valore, descrizione: prefisso.descrizione });
                    });
                    callback();
                },
                (error) => messaggiFctr.processaResponse(error)
            );
        };

        this.getModalitaInvio = () => {
            if (!datiCredenzialiService.listaModalitaInvio || !datiCredenzialiService.listaModalitaInvio.length) {
                datiCredenzialiService.listaModalitaInvio = [];
                datiCredenzialiService.getListaModalitaInvio().then(
                    (resp) => {
                        datiCredenzialiService.listaModalitaInvio = resp.data.result;
                    },
                    (error) => messaggiFctr.processaResponse(error)
                );
            }
        };

        this.init = () => {
            this.getModalitaInvio();

            // Recupero dei contatti
            if (!datiCredenzialiService.listaPrefissi) {
                this.getPrefissi(this.checkContattiAnagrafici);
            } else {
                this.checkContattiAnagrafici();
            }
        };

        this.init();
    };

    DatiCredenzialiCtrl.$inject = [
        'MitomMessaggiFctr',
        'MitomDatiCredenzialiService',
        'MitomGestioneUtenteService'
    ];

    var TemplateUrl = function(CONSTANTS) {
        return (
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'mitoman-gestione-utente/mitoman-dati-credenziali/datiCredenziali.component.html'
        );
    };
    TemplateUrl.$inject = ['Mitom_CONSTANTS'];

    var DatiCredenzialiComponent = {
        controller: DatiCredenzialiCtrl,
        controllerAs: 'datiCredenzialiCtrl',
        templateUrl: TemplateUrl
    };

    angular
        .module('cbl.mitomanager.wa')
        .component('mitomdatiCredenziali', DatiCredenzialiComponent);
})();